var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UserModel_1;
import decode from 'jwt-decode';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { onCreateFactoryAuth } from './auth';
let UserModel = UserModel_1 = class UserModel {
    // 单例模式 全局唯一
    constructor() {
        this.Auth = onCreateFactoryAuth();
        // super();
        // if (!lodash.isEmpty(UserModel.UserModel)) {
        //   return UserModel.UserModel;
        // }
        // this.onInit({ type: 'object', storageKey: 'user', storageLoading: false });
        UserModel_1.UserModel = this;
    }
    /**
     * 工厂函数
     * @static
     * @return {*}
     * @memberof UserModel
     */
    static onCreateFactoryUser() {
        if (!lodash.isEmpty(UserModel_1.UserModel)) {
            return UserModel_1.UserModel;
        }
        return new UserModel_1();
    }
    /**
     * 兼容 之前的 value
     * @readonly
     * @memberof UserModel
     */
    get value() {
        return lodash.assign({}, this.Auth.Info);
    }
    /**
     * 兼容 之前的方法
     */
    merge(value) {
        value = lodash.merge({}, this.value, value);
        this.Auth.onSaveInfo(value);
    }
    /**
     * 兼容 之前的方法
     */
    set(value) {
        this.Auth.onSaveInfo(value);
    }
    /**
     * token 解析
     * @readonly
     * @memberof SystemController
     */
    get decodeToken() {
        try {
            if (this.Auth.AccessToken) {
                return decode(this.Auth.AccessToken);
            }
        }
        catch (error) {
            console.error(error);
        }
        return {};
    }
    get username() {
        return (lodash.get(this.decodeToken, 'username', '') ||
            lodash.get(this.value, 'loginUsername', ''));
    }
    /** 身份id */
    get identityId() {
        return (lodash.get(this.decodeToken, 'identityId', '') ||
            lodash.get(this.decodeToken, 'identityIds', ''));
    }
    get userId() {
        return lodash.head(lodash.compact([
            lodash.get(this.decodeToken, 'sub', ''),
            this.username && `username_${this.username}`, //如果没有userId,则取username
        ]));
    }
    /** token */
    // @computed
    // public get token() {
    //   return this.value.token;
    // }
    /** 帆软 token */
    get frToken() {
        return this.value.frToken;
    }
    get isAppAdmin() {
        return this.value.isAppAdmin;
    }
    get isSuperAdmin() {
        return this.value.isSuperAdmin;
    }
    get itcode() {
        return this.value.itcode;
    }
    /** BU */
    get BU() {
        return lodash.get(this.value, 'businessType');
    }
    /** 用户分享码 */
    get shareCode() {
        return lodash.get(this.value, 'userId', '');
    }
    /** 埋点 ID */
    get _la_lenovo_id() {
        return this.value.itcode;
    }
    /** 是否是T1用户 */
    //   @computed
    //   public get isT1() {
    //     const channelTypeList = lodash.get(this.value, 'channelTypeList');
    //     return lodash.some(channelTypeList, (item) => {
    //       return item.typeId == '19';
    //     });
    //   }
    /**
     * 对比Token 信息
     * @param {*} AccessToken
     * @return {*}
     * @memberof UserModel
     */
    eqAccessToken(AccessToken) {
        AccessToken = lodash.defaultTo(AccessToken, this.Auth.AccessToken);
        return lodash.eq(lodash.get(this.value, 'AccessToken'), AccessToken);
    }
    /**
     * 是否允许SN上报
     */
    get allowedSNReport() {
        return lodash.get(this.value, 'allowedSNReport');
    }
};
__decorate([
    computed
], UserModel.prototype, "value", null);
__decorate([
    computed
], UserModel.prototype, "decodeToken", null);
__decorate([
    computed
], UserModel.prototype, "username", null);
__decorate([
    computed
], UserModel.prototype, "identityId", null);
__decorate([
    computed
], UserModel.prototype, "userId", null);
__decorate([
    computed
], UserModel.prototype, "frToken", null);
__decorate([
    computed
], UserModel.prototype, "isAppAdmin", null);
__decorate([
    computed
], UserModel.prototype, "isSuperAdmin", null);
__decorate([
    computed
], UserModel.prototype, "itcode", null);
__decorate([
    computed
], UserModel.prototype, "BU", null);
__decorate([
    computed
], UserModel.prototype, "shareCode", null);
__decorate([
    computed
], UserModel.prototype, "_la_lenovo_id", null);
UserModel = UserModel_1 = __decorate([
    BindAll()
], UserModel);
export const onCreateFactoryUser = UserModel.onCreateFactoryUser;
